import { STATIC_DOMAINS } from 'mk/settings';

export default '//' + STATIC_DOMAINS.files[0] + '/';
